// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partslistcatainersorders {
  display: flex;
  gap: 1rem;
}

.partslist_catainersorders {
  display: flex;
  gap: 1rem;
  margin: 1rem;
  justify-content: space-between;
  width: 96%;
}

.button-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.AddpartsbulkAddpartsbulk {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  height: 40px;
  font-size: 14px;
  padding: 0rem 1.4rem;
  white-space: nowrap;
}

.AddpartsbulkAddpartsbulk_s {
  background: #e4ecf7;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  padding: 0rem 1.4rem;
  border: none;
  border-radius: 5px;
  height: 40px;
  color: #0c3688;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
}

button.download-part-btn:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
  cursor: not-allowed;
}

@media screen and (max-width: 768px) {
  .partslistcatainersorders button {
    height: 40px !important;
    font-size: 12px !important;
  }
  .button-flex {
    justify-content: start;
    gap: 20px;
  }
  .button-flex button {
    height: 40px !important;
  }
}
@media screen and (max-width: 480px) {
  .button-flex {
    justify-content: start;
    gap: 18px;
    flex-wrap: wrap;
  }
  .button-flex .download-order-excel-btn, .button-flex .partslistcatainersorders {
    width: 100%;
  }
  .AddpartsbulkAddpartsbulk, .AddpartsbulkAddpartsbulk_s {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PartorderslistButtons/partsorder.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;AACJ;;AACA;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAEJ;;AACE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAEJ;;AAAE;EACE,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAGJ;;AAAE;EACE,mEAAA;EACA,mBAAA;AAGJ;;AAAE;EACE;IACE,uBAAA;IACA,0BAAA;EAGJ;EAAE;IACE,sBAAA;IACA,SAAA;EAEJ;EACE;IACE,uBAAA;EACJ;AACF;AAEE;EACE;IACE,sBAAA;IACA,SAAA;IACA,eAAA;EAAJ;EAEI;IACE,WAAA;EAAN;EAIE;IACE,WAAA;EAFJ;AACF","sourcesContent":[".partslistcatainersorders{\n    display: flex;\n    gap: 1rem;\n  }\n.partslist_catainersorders{\n    display: flex;\n    gap: 1rem;\n    margin: 1rem;\n    justify-content: space-between;\n    width: 96%;\n  }\n\n  .button-flex{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .AddpartsbulkAddpartsbulk {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    border: none;\n    border-radius: 5px;\n    color: #ffffff;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    height: 40px;\n    font-size: 14px;\n    padding: 0rem 1.4rem;\n    white-space: nowrap;\n  }\n  .AddpartsbulkAddpartsbulk_s {\n    background: #e4ecf7;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    padding: 0rem 1.4rem;\n    border: none;\n    border-radius: 5px;\n    height: 40px;\n    color: #0c3688;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    white-space: nowrap;\n  }\n\n  button.download-part-btn:disabled {\n    background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n    cursor: not-allowed;\n  }\n\n  @media screen and (max-width:768px) {\n    .partslistcatainersorders button{\n      height: 40px !important;\n      font-size: 12px !important;\n    }\n\n    .button-flex{\n      justify-content: start;\n      gap: 20px;\n    }\n\n    .button-flex button{\n      height: 40px !important;\n    }\n  }\n\n  @media screen and (max-width: 480px) {\n    .button-flex{\n      justify-content: start;\n      gap: 18px;\n      flex-wrap: wrap;\n\n      .download-order-excel-btn, .partslistcatainersorders{\n        width: 100%;\n      }\n    }\n\n    .AddpartsbulkAddpartsbulk, .AddpartsbulkAddpartsbulk_s{\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
